import { NgModule, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientSearchModule } from '@roosevelt/client-ui-lib';
import { AvailableReportsModule, BillingModule as BillingLibraryModule } from '@roosevelt/billing-lib';
import { ButtonModule } from '@roosevelt/common-ui-lib/button';
import { CheckboxModule } from '@roosevelt/common-ui-lib/checkbox';
import { DialogModule } from '@roosevelt/common-ui-lib/dialog';
import { InputModule } from '@roosevelt/common-ui-lib/input';
import { LoaderModule } from '@roosevelt/common-ui-lib/loader';
import { Lux } from '@roosevelt/common-ui-lib/core';
import { RadioModule } from '@roosevelt/common-ui-lib/radio';
import { SelectModule } from '@roosevelt/common-ui-lib/select';
import { BillingComponent } from './billing.component';
import { BillingContainer } from './billing.container';
import { AchPaymentComponent } from './ach-payment/ach-payment.component';
import { AchPayerAddressComponent } from './ach-payer-address/ach-payer-address.component';
import { IBmtBillingState } from '../store/billing/state';
import { initialStateMaBillingState } from '../store/billing/initialState';
import { syncLuxSliceToStorage } from '../shared/lux-storage-sync';

@NgModule({
  declarations: [BillingComponent, BillingContainer, AchPaymentComponent, AchPayerAddressComponent],
  imports: [
    CommonModule,
    ButtonModule,
    InputModule,
    RadioModule,
    ReactiveFormsModule,
    LoaderModule,
    FormsModule,
    BillingLibraryModule,
    AvailableReportsModule,
    SelectModule,
    ClientSearchModule,
    DialogModule,
    CheckboxModule
  ]
})
export class BillingModule {
  constructor(lux: Lux<{ billingState: IBmtBillingState }>, injector: Injector) {
    const billingState = JSON.parse(sessionStorage.getItem('ma-billing-state') || 'null');
    lux.register('billingState', billingState || initialStateMaBillingState);
    syncLuxSliceToStorage(lux, injector, sessionStorage, 'ma-billing-state', state => state.billingState);
  }
}
